import axios from "axios";

const httpSurvey = axios.create({
  baseURL: import.meta.env.REACT_APP_BASE_URL,
});

export default httpSurvey;
